document.addEventListener('DOMContentLoaded', function () {
    function updateCardTransforms() {
        // Only run the function if window width is above 991px
        if (window.innerWidth > 991) {
            const cards = document.querySelectorAll('.card');

            cards.forEach(card => {
                const bodyWrap = card.querySelector('.body-wrap');
                const innerText = card.querySelector('.inner-text');

                if (bodyWrap && innerText) {
                    const bodyWrapHeight = bodyWrap.offsetHeight;
                    innerText.style.transform = `translateY(${bodyWrapHeight}px)`;
                }
            });
        } else {
            // Reset the transform if width is 991px or below
            const cards = document.querySelectorAll('.card .inner-text');
            cards.forEach(innerText => {
                innerText.style.transform = '';
            });
        }
    }

    // Run on page load
    updateCardTransforms();

    // Add timeout to resize event
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateCardTransforms, 900);
    });
});
